import { ErrorModal } from '@leprecoins/error-modal';
import { useUnit } from 'effector-react';
import { PropsWithChildren } from 'react';
import { gameModel } from 'entities/game';
import { createComposableProvider } from 'shared/lib';
import '@leprecoins/error-modal/style.css';

export const ErrorModalProvider = ({ children }: PropsWithChildren) => {
	const opened = useUnit(gameModel.errorModalToggler.$active);

	return (
		<>
			{children}
			<ErrorModal opened={opened} />
		</>
	);
};

export const withErrorModal = createComposableProvider(ErrorModalProvider);
